// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cD7P","toggleWrap":"styles_toggleWrap__3gnY_","content":"styles_content__3Elvv","selectAreaCode":"styles_selectAreaCode__2VCG5"};